const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getEvents(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.severity) params.append('severity', filters.severity);
  if (filters.type) params.append('type', filters.type);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.correlationId) params.append('correlationId', filters.correlationId);
  if (filters.limit) params.append('limit', filters.limit.toString());
  if (filters.offset) params.append('offset', filters.offset.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/integrations/energyhub/events${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch events');
  }
  
  return response.json();
}

export async function getEvent(orgId, eventId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/integrations/energyhub/events/${eventId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch event');
  }
  
  const data = await response.json();
  return data.event;
}
